/** @jsx jsx */

import { Surface, Text } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

import Preview from './Preview';

const Styles = {
  content: css`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 50px;
    padding: 15px;

    @media (min-width: 750px) : {
      padding: 20px 20px 20px 25px;
    }
  `,
  main: css`
    flex: 1;
  `,
};

function JoinIntegration() {
  return (
    <Surface borderColor="gray40">
      <div css={Styles.content}>
        <div css={Styles.main}>
          <Text color="gray80" tag="h3" type="pageHeader9">
            Want access to your integration?
          </Text>
          <Text color="gray80" margin="15px 0 0" tag="p" type="paragraph3">
            Collaborators can log in to view performance data, user feedback,
            and access embed tools, but can't make changes. Simply{' '}
            <b>log in to Zapier (or sign up)</b> first, then join your
            integration on the <b>My Integrations</b> page.
          </Text>
        </div>
        <Preview />
      </div>
    </Surface>
  );
}

export default JoinIntegration;
